/**
 * @generated SignedSource<<314ed35f652731cebaedbd0043886a30>>
 * @relayHash fcde14ee9d1ec0e3c9fb1781be4474aa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8a83ab43de8aebd4391c278fd211b54d395b77175a7c7ef77e1d6783a481d13a

import type { ConcreteRequest } from 'relay-runtime';
export type useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery$variables = Record<PropertyKey, never>;
export type useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly hasPersonalSpace: boolean | null | undefined;
      readonly space: {
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly team: string | null | undefined;
  } | null | undefined;
};
export type useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery = {
  response: useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery$data;
  variables: useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "team"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPersonalSpace"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fcde14ee9d1ec0e3c9fb1781be4474aa",
    "id": "8a83ab43de8aebd4391c278fd211b54d395b77175a7c7ef77e1d6783a481d13a",
    "metadata": {},
    "name": "useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery",
    "operationKind": "query",
    "text": "query useIsEligibleForNthUserHomeOnboardingRevampGetUserDataQuery{user:confluence_atlassianUser(current:true){id,team,confluence{hasPersonalSpace,space{id,key}}}}"
  }
};
})();

(node as any).hash = "2d292d6e6d3ff58f591364b4a8548ff0";

export default node;
